import { type JSX } from 'react';

import { StyleSheet, Text } from '@react-pdf/renderer';

import { PDF_FONTS, PDF_PAGE, PDF_SPACING } from '../lib/pdfTokens';

const TEXT = {
  fontFamily: PDF_FONTS.sans,
  fontWeight: 300,
  fontSize: 10,
  lineHeight: 1.35,
  color: '#25252A',
  top: PDF_PAGE.marginTop,
} as const;

const styles = StyleSheet.create({
  left: {
    ...TEXT,
    position: 'absolute',
    left: PDF_PAGE.marginLeft,
  },
  right: {
    ...TEXT,
    position: 'absolute',
    right: PDF_PAGE.marginRight,
    textAlign: 'right',
  },
  spacer: {
    marginTop: PDF_PAGE.marginTop + PDF_SPACING[6],
  },
});

export function ReportPageHeader(): JSX.Element {
  return (
    <>
      <Text
        style={styles.left}
        fixed>
        Relatório ilustrativo
      </Text>
      <Text
        style={styles.right}
        render={({ pageNumber }) => `Redação Nota 1000  |  ${pageNumber}`}
        fixed
      />
    </>
  );
}
